import { CREATOR_PROFILE } from "../../constants/routes";
import { Logo, Title } from "@orgmym/leeloo-core";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ButtonBack } from "../button-back/ButtonBack";
import { Icon } from "../icon/Icon";
import * as styles from "./header.css";

interface HeaderProps {
  className?: string;
  title?: string;
  withButtonBack?: boolean;
  withMobileButtonBack?: boolean;
  withMobileCloseIcon?: boolean;
  backButtonLabel?: string;
  rightItem?: React.ReactNode;
  leftItem?: React.ReactNode;
  withLogo?: boolean;
  onClick?: () => void;
}

export function Header({
  className,
  title,
  withButtonBack,
  withMobileButtonBack,
  backButtonLabel,
  withMobileCloseIcon,
  rightItem,
  leftItem,
  withLogo,
  onClick,
  ...rest
}: HeaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(styles.header, className)}
      data-testid="header"
      {...rest}
    >
      {withMobileCloseIcon && (
        <Icon
          className={styles.closeIcon({
            withMobileCloseIcon: withMobileCloseIcon
          })}
          name="close"
          data-testid="header-mobile-close-icon"
          onClick={() => window.location.assign(CREATOR_PROFILE)}
          size="large"
        />
      )}
      {withButtonBack && (
        <ButtonBack
          className={styles.buttonBack({
            withButtonBack: withButtonBack
          })}
          onClick={onClick}
          label={t(backButtonLabel || "common_back_button_label")}
          data-testid="header-button-back"
        />
      )}
      {withMobileButtonBack && !withMobileCloseIcon && (
        <ButtonBack
          className={styles.mobileButtonBack({
            withMobileButtonBack: withMobileButtonBack
          })}
          onClick={onClick}
          label={t(backButtonLabel || "common_back_button_label")}
          data-testid="button-back"
        />
      )}
      {withLogo && <Logo className={styles.logo} />}
      {leftItem && <div>{leftItem}</div>}
      <Title as="h3" data-testid="header-title" className={styles.title}>
        {title}
      </Title>
      {rightItem && <div className={styles.rightAction}>{rightItem}</div>}
    </div>
  );
}
